<template>
    <div>
        <p class="d-flex align-items-center">
            <strong class="border-end border-dark pe-1">{{ accessory.currentVersion.stockMention }}</strong>
            <strong class="ps-1">
                <free-delivery-modal
                    v-if="accessory.popinData"
                    id="popin-free-delivery"
                    :delivery-modal-title="accessory.popinData.deliveryModalTitle"
                    :eco-label="accessory.popinData.ecoLabel"
                    :eco-label-mention="accessory.popinData.ecoLabelMention"
                    :free-delivery-label="accessory.popinData.freeDeliveryLabel"
                    :free-delivery-modal-id="'popin-free-delivery'"
                    :other-address-delivery-fees="accessory.popinData.otherAddressDeliveryFees"
                    :other-address-text="accessory.popinData.otherAddressText"
                    :other-address-title="accessory.popinData.otherAddressTitle"
                    :pickup-delivery-text="accessory.popinData.pickupDeliveryText"
                    :pickup-delivery-title="accessory.popinData.pickupDeliveryTitle"
                    :shop-delivery-text="accessory.popinData.shopDeliveryText"
                    :shop-delivery-title="accessory.popinData.shopDeliveryTitle"
                    :stock-and-delivery-mention="accessory.deliveryMention"
                />
            </strong>
        </p>
        <div v-if="isLoading" class="item-spinner d-flex justify-content-center">
            <ob1-progress-indicators :size="50" type="undetermined" />
        </div>
        <div v-else id="addAccessoryCta">
            <ob1-boutons
                ref="add-accessory-cta"
                :label="accessory.currentVersion.boutonsDTO.label"
                :is-primary="true"
                :is-disabled="!isAddButtonEnabled"
                @ob1-boutons-click="onAddAccessoryButtonClick"
            />
        </div>

        <ob1-popin-modal2
            :id="accessory.addToCartDTO.popinModalDTO.id"
            :aria-labelledby="accessory.addToCartDTO.popinModalDTO.label"
            :show-close-button="false"
        >
            <h4>{{ accessory.addToCartDTO.popinTitle }}</h4>
            <div class="d-flex justify-content-center justify-content-md-start">
                <div class="d-flex flex-column">
                    <ob1-boutons
                        data-bs-dismiss="modal"
                        :label="accessory.addToCartDTO.continueShopping"
                        :is-secondary="true"
                        class="my-2"
                    />

                    <ob1-boutons
                        :label="accessory.addToCartDTO.liensDTO.text"
                        :href="cartUrl"
                        :is-button="false"
                        :is-primary="true"
                    />
                </div>
            </div>
        </ob1-popin-modal2>
    </div>
</template>

<script>

import FreeDeliveryModal from "../common/components/FreeDeliveryModal.vue";

export default {
    components: {FreeDeliveryModal},
    props: {
        accessory: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        },
        isAddButtonEnabled: {
            type: Boolean,
            required: true
        },
        cartUrl: {
            type: String,
            required: true,
        }
    },
    methods: {
        onAddAccessoryButtonClick(event) {
            this.$emit('accessory-cta-click', event);
        }
    }
}
</script>
